import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
import permissionDirective from "@/directives/permission";

import base from "@/api/base";
base.init();

const elementAlert = Vue.prototype.$alert;
Vue.prototype.$alert = (...args) =>
  elementAlert(...args).catch((action) => {
    if (action !== "cancel" && action !== "close") throw action;
  });
Vue.config.productionTip = false;
Vue.directive("permission", permissionDirective);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
